import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import api, { OWNER_EMAIL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Banner globale visibile SOLO all'owner quando la maintenance è attiva. */
export default function MaintenanceBanner() {
  const { user } = useAuth();
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/maintenance/status");
        if (!cancelled) setActive(!!data?.maintenance_mode);
      } catch {
        if (!cancelled) setActive(false);
      }
    };
    load();
    // Refresh ogni 30s (a poll basso — cambia raramente)
    const t = setInterval(load, 30000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [user]);

  if (!user || !active) return null;
  const isOwner = user.email && user.email.trim().toLowerCase() === OWNER_EMAIL;
  if (!isOwner) return null;

  return (
    <div
      data-testid="maintenance-global-banner"
      className="bg-lavender-900 text-white text-xs sm:text-sm px-4 py-2 flex items-center justify-center gap-2 flex-wrap"
    >
      <Wrench className="h-4 w-4 shrink-0" />
      <span>Modalità manutenzione attiva — solo tu hai accesso.</span>
      <Link to="/configurazione/demo-tools" className="underline font-medium ml-1">
        Disattivala da Demo Tools
      </Link>
    </div>
  );
}
